import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Dropdown, Avatar, Icon, Modal, Spin } from 'antd';
import moment from 'moment';
import _isEqual from 'lodash/isEqual';

import ApplyChangesModal from '../../containers/ApplyChangesModal';
import HeaderMenu, { LoginDropDown } from './HeaderMenu';
import {
	headerMobileStyle,
	AvatarWrapper,
	Status,
	MobileWrapper,
	Wrapper
} from './style';
import {
	DASH_NAV_HOLLA_ICON,
	DASH_NAV_WALLET_ICON,
	PLUGIN_TAB_ICON
	// APPLY_REFRESH_ICON
} from '../../config/media';
import { getCookie, returnComma } from '../../common/utils';
import { getStats, getUserInfo, getXhtPrice } from '../../common/fetch';
import {
	LOGO_WHITE,
	BREAK_POINT,
	GNB_LIST_PC,
	GNB_LIST_MOBILE,
} from '../../config/constants';
import { removeCookie } from '../../common/utils';

const terminateExchangeData = {
	yellow: { class: "status_warning", msg: "Your exchange subscription will expire soon. Visit the billing page to renew your exchange plan." },
	orange: { class: "status_about_to_terminate", msg: "Your exchange has a pending bill. To avoid service disruption to your platform please address any pending invoices within the billing page." },
	red_level1: { class: "status_terminated", msg: "This exchange has been marked as dormant. To prevent ☠termination please take the advised steps" },
	red_level2: { class: "status_terminated", msg: "Your exchange has been ☠terminated due to inactivity." }
}

const { Header } = Layout;

class TopHeader extends Component {
	state = {
		isMobile: false,
		pathname: '',
		isMobileMenu: false,
		isLoading: true,
		indicator: { class: "status_warning", msg: "Your account is not secure. Turn on two-factor authentication in your" },
		isShowExchangeTerminateMsg: false,
	};

	componentWillReceiveProps(next) {
		const { location } = next;
		this.setState({
			pathname: location.pathname,
		});
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
		this.getData(true);
		// this.getUserData();
		this.interval = setInterval(() => {
			this.getData()
		}, 300000); // every 5 minutes fetching again
	}

	componentDidUpdate(prevProps, prevState) {
		if (!_isEqual(this.props.constant, prevProps.constant)) {
			this.handleTerminalExchange();
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	handleTerminalExchange = () => {
		const { exchange, constant, setConstant} = this.props;
		const { type, is_paid, expiry, is_terminated } = exchange[0];
		const { unpaidExchangeGracePeriod } = constant;
		let indicator = { class: "status_warning", msg: "Your account is not secure. Turn on two-factor authentication in your" };
		
		let Today = moment().format();
		let tempExpiry = moment(expiry).format();
		const expiryDate = moment(tempExpiry).add(unpaidExchangeGracePeriod, 'days').format();
		const halfexpiryDate = moment(tempExpiry).add(unpaidExchangeGracePeriod / 2, 'days').format();	
		const expireDate_Diff = moment(Today).diff(moment(tempExpiry), 'days');
		const halfexpireDate_Diff = moment(halfexpiryDate).diff(moment(Today), 'days');
		const lastDate_Diff = moment(expiryDate).diff(moment(Today), 'days');
		let isShowExchangeTerminateMsg = false;

		if (type === "Cloud" && is_paid && expireDate_Diff > 0) {
			if (is_terminated) {
				indicator = terminateExchangeData.red_level2;
				isShowExchangeTerminateMsg = true;
				setConstant({ isExchangeExpired: true });
			} else if ((expireDate_Diff <= 5 || halfexpireDate_Diff >= 0)) {
				indicator = terminateExchangeData.yellow;
				isShowExchangeTerminateMsg = true;
			} else if ((expireDate_Diff > 5 || halfexpireDate_Diff <= 0) && lastDate_Diff >=0) {
				indicator = terminateExchangeData.orange;
				isShowExchangeTerminateMsg = true;
			} else if (!is_terminated && lastDate_Diff < 0) {
				indicator = terminateExchangeData.red_level1;
				isShowExchangeTerminateMsg = true;				
			}
		}		
		this.setState({ indicator, isShowExchangeTerminateMsg })
	}

	handleResize = (e) => {
		const { innerWidth } = window;
		if (innerWidth <= BREAK_POINT && !this.state.isMobile) {
			this.setState({ isMobile: true });
		} else if (innerWidth > BREAK_POINT && this.state.isMobile) {
			this.setState({ isMobile: false });
		}
	};

	getData = async (isInitial = false) => {
		const { statActions } = this.props;
		const stat = {};
		if (isInitial) {
			statActions.updateDataRequest();
		}
		try {
			const res = await getStats();
			stat.no = res.data.no;
			stat.amount = res.data.amount;
		} catch (error) {
			this.setState({ isLoading: false });
			statActions.updateDataFailure();
		}
		try {
			const res = await getXhtPrice();
			stat.xht_price = res.last === undefined ? 0 : res.last;
		} catch (error) {
			console.error(error);
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false });
		statActions.updateData(stat);
	};

	getUserData = async () => {
		const { userActions } = this.props;
		try {
			const res = await getUserInfo();
			userActions.readData(res.data);
		} catch (error) {
			console.error(error);
		}
	};

	confirmModal = () => {
		const { history } = this.props;
		Modal.confirm({
			title: 'Do you want to login?',
			onOk: () => {
				history.push('/');
				history.go(0);
			},
			onCancel: () => { },
		});
	};

	renderLinks = () => {
		const { user, location } = this.props;
		const { pathname, isMobile } = this.state;

		if (user.id === 0) {
			return (
				<Link
					to={location.pathname}
					className={pathname.indexOf('project') >= 0 ? 'active' : ''}
					onClick={() => {
						this.setState({ isMobileMenu: false });
					}}
				>
					Projects
				</Link>
			);
		}

		if (isMobile) {
			return GNB_LIST_MOBILE.map((item) => (
				<Link
					key={item.key}
					to={item.url}
					onClick={() => {
						this.setState({ isMobileMenu: false });
					}}
				>
					{item.name}
				</Link>
			));
		}

		return GNB_LIST_PC.map((item) => {
			if (item.key === 'home') {
				return (
					<Link
						key={item.key}
						to={item.url}
						className={pathname === '/' ? 'active' : ''}
					>
						{item.name}
					</Link>
				);
			}
			return (
				<Link
					key={item.key}
					to={item.url}
					className={pathname.indexOf(item.key) >= 0 ? 'active' : ''}
				>
					{item.name}
				</Link>
			);
		});
	};

	renderExchangeStatus = () => {
		const { exchange } = this.props;
		if (!exchange.length) {
			return null;
		}
		let exchangeData = exchange[0];
		if (exchangeData.type === 'Cloud') {
			if (moment(exchangeData.expiry).diff(moment(), 'days') <= 0 ||
				moment(exchangeData.expiry).diff(moment(), 'days') <= 2) {
				return (
					<div className="exchange_status_container status_expired">
						<span className="main">Your cloud exchange is about to expire and will self-terminate.</span> Go to your billing page{' '}
						<Link to={"/billing"}>here</Link> to make a payment.
					</div>
				);
			} else if (!exchangeData.is_paid) {
				return (
					<div className="exchange_status_container status_warning">
						<span className="main">Your cloud exchange has a pending invoice.</span> Go to your billing page{' '}
						<Link to="/billing">here</Link> to make a payment.
					</div>
				);
			} else {
				return null;
			}
		} else {
			if (moment(exchangeData.expiry).diff(moment(), 'days') <= 0) {
				return (
					<div className="exchange_status_container status_warning">
						<span className="main">Your trial exchange has expired.</span> Upgrade your exchange{' '}
					</div>
				)
			} else if (moment(exchangeData.expiry).diff(moment(), 'days') <= 7) {
				return (
					<div className="exchange_status_container status_warning">
						<span className="main">Your trial exchange will expire in{' '}
							{moment(exchangeData.expiry).diff(moment(), 'days')}
							days. </span> Collateralize {' '}
						<Link to="/collateral">here</Link> or make your exchange{' '}
						<Link to="/collateral"> public</Link> to apply for sponsorship
					</div>
				)
			} else {
				return null;
			}
		}
	};
	renderSecurityStatus = () => {
		const { user, exchange } = this.props;
		const { indicator, isShowExchangeTerminateMsg } = this.state;
		if ((!user.otp_enabled && exchange && exchange[0] && exchange[0].is_running) || isShowExchangeTerminateMsg) {
			return (
				<div className={`exchange_status_container ${indicator.class}`}>
					<span className="main">
						{indicator.msg}
					</span>{' '}
					&nbsp;
					{
						exchange[0].is_terminated ? 
						<Link to ={  "/billing"}>Visit here</Link>
						:
						<Link to ={  "/mypage/modify-password"}>Profile Page</Link>
					}
				</div>
			)
		} else {
			return null;
		}
	}

	handleApply = () => {
		this.props.requestApplyChangesModal({ isOpenApplyModal: true });
	};

	render() {
		const { user, exchange } = this.props;
		const { isMobile, pathname, isMobileMenu, isLoading, isShowExchangeTerminateMsg } = this.state;
		const { xht_price, no } = this.props.state;
		// const { xht_available = 0 } = this.props.user.balance;
		const is_2fa = ((!user.otp_enabled && exchange && exchange[0] && exchange[0].is_running) || isShowExchangeTerminateMsg);

		const email = getCookie('email');
		let userName = '';
		if (email) {
			userName = email.split('@')[0];
		}
		if (isLoading) {
			return (
				<Wrapper>
					<Header className="header">
						<Spin />
					</Header>
				</Wrapper>
			);
		}
		if (isMobile) {
			return (
				<MobileWrapper>
					<Icon
						type="menu"
						className={is_2fa ? "menu_mobile_icon" : "menu-icon"}
						style={{ fontSize: '22px', color: '#fff' }}
						onClick={() => {
							this.setState({ isMobileMenu: !isMobileMenu });
						}}
					/>
					<div className={is_2fa ? "header-wrapper" : ""}>
						<div>
							{this.renderSecurityStatus()}
						</div>
						{this.props.exchange.length && this.props.exchange[0].is_completed ? <Header className="header" style={headerMobileStyle}>
							<Link
								to="/"
								style={{
									color: '#fff',
									display: 'block',
									textAlign: 'center',
									position: 'absolute',
									left: '50%',
									transform: 'translateX(-50%)',
								}}
							>
								<img
									src={LOGO_WHITE}
									alt="logo"
									style={{ height: '24px' }}
								/>
							</Link>
							<Dropdown
								overlay={user.id === 0 ? LoginDropDown : HeaderMenu}
								style={{ flex: 1 }}
							>
								<AvatarWrapper>
									<Avatar icon="user" />
								</AvatarWrapper>
							</Dropdown>
						</Header> :
							<Header className={is_2fa ? "header move_top_bar" : "header"}>
								<Link
									to={{ pathname: '/', state: { isLogout: true } }}
									onClick={() => {
										removeCookie('id_token');
										removeCookie('email');
									}}
									className='logout'
								>
									Logout
								</Link>
							</Header>
						}
					</div>
					{!!this.props.exchange.length &&
						<div className="xht-header-status">
							<div className="flex-box">
								<p className="col1">
									XHT Price: <strong ><a target='_blank' rel="noopener noreferrer" href="https://pro.hollaex.com/trade/xht-usdt">{returnComma(xht_price)} USDT</a> </strong>
								</p>
								<p className="col2">
									<strong>Number of Exchange: </strong>
									<span>{returnComma(parseInt(no, 10))}</span>
								</p>
							</div>
						</div>}
					{isMobileMenu ? (
						<div className="mobile-nav">{this.renderLinks()}</div>
					) : null}
				</MobileWrapper>
			);
		}
		return (
			<Wrapper className={is_2fa ? "pt-70" : ""}>
				<div>
					{this.renderSecurityStatus()}
				</div>
				{this.props.exchange.length && this.props.exchange[0].is_completed ? <Header className={is_2fa ? "header move_top_bar" : "header"}>
					<div className="tabs-wrapper">
						<Link
							key={'exchange'}
							to={'/'}
							className={
								!pathname.includes('/project') &&
									!pathname.includes('/wallet') &&
									!pathname.includes('/confirm-withdraw') &&
									!pathname.includes('/plugin') &&
									!pathname.includes('/mypage')
									? 'tab active-tab'
									: 'tab'
							}
						>
							<img
								src={DASH_NAV_HOLLA_ICON}
								alt="exchange"
								className="nav-icon"
							/>
							My Exchange
						</Link>
						{/*<Link
							key={'project'}
							to={'/project'}
							className={pathname.includes('/project') ? 'tab active-tab' : 'tab'}
						>
							<img
								src={
									pathname.includes('/project')
										? DASH_NAV_PROJECT_ICON
										: DASH_NAV_PROJECT_ICON
								}
								alt="project"
								className="nav-icon"
							/>
							Other Projects
							</Link>*/}
						<Link
							key={'plugin'}
							to={'/plugin'}
							className={pathname.includes('/plugin') ? 'tab active-tab' : 'tab'}
						>
							<img
								src={
									pathname.includes('/plugin')
										? PLUGIN_TAB_ICON
										: PLUGIN_TAB_ICON
								}
								alt="plugin"
								className="nav-icon"
							/>
							Plugins
						</Link>
					</div>
					{/* <Logo
						onClick={() => {
							this.props.history.push('/');
						}}
					/> */}
					<Status className="current-status">
						<p>
							XHT Price: <strong ><a target='_blank' rel="noopener noreferrer" href="https://pro.hollaex.com/trade/xht-usdt">{returnComma(xht_price)} USDT</a> </strong>
						</p>
						<p className="last">
							Number of Exchange: <span>{returnComma(no)}</span>
						</p>
					</Status>
					{user.id !== 0 ? (
						<div className="right-header">
							{/*<div className="tab clickable" onClick={this.handleApply}>
								<img src={APPLY_REFRESH_ICON} className="nav-icon" alt="apply on kit" />
								Apply latest changes
							</div>*/}
							<Link
								key={'wallet'}
								to={'/wallet'}
								className={
									(pathname.includes('/wallet') ||
										pathname.includes('/confirm-withdraw'))
										? 'tab active-tab'
										: 'tab'
								}
							>
								<div>
									<img
										src={
											pathname.includes('/wallet')
												? DASH_NAV_WALLET_ICON
												: DASH_NAV_WALLET_ICON
										}
										alt="wallet"
										className="nav-icon"
									/>
									Account Wallet
								</div>
							</Link>
							{/* <Dropdown
								overlay={user.id === 0 ? LoginDropDown : HeaderMenu}
								style={{ flex: 1 }}
								trigger={['click']}
							> */}
							<span className="tab-divider"></span>
							<Link
								key={'profile'}
								to={'/mypage'}
								className={pathname.includes('/mypage') ? 'tab active-tab' : 'tab'}
							>
								<AvatarWrapper>
									<span className="name">{userName}</span>
									<Avatar size="small" icon="user" />
								</AvatarWrapper>
							</Link>
							{/* </Dropdown> */}
						</div>
					) : (
						<div className="right-header">
							<Link
								className="login-btn"
								to={{
									pathname: '/login',
									state: {
										project: this.props.location.pathname,
									},
								}}
							>
								Login
							</Link>
							<Link to="/signup">SignUp</Link>
						</div>
					)}
				</Header> :
					<Header className={is_2fa ? "header move_top_bar" : "header"}>
						<Link
							to={{ pathname: '/', state: { isLogout: true } }}
							onClick={() => {
								removeCookie('id_token');
								removeCookie('email');
							}}
							className='logout'
						>
							Logout
						</Link>
					</Header>
				}
				{/* {this.renderExchangeStatus()} */}
				{/* <div className="gnb">
					<div className="link-container">{this.renderLinks()}</div>
					<div className="account-balance">
						{user.id !== 0 && (
							<Link
								to="/credit"
								className={
									pathname.indexOf('credit') >= 0 ? 'active' : ''
								}
							>
								XHT Balance: {returnComma(xht_available)}
							</Link>
						)}
					</div>
				</div> */}
				{user.id !== 0
					? (<ApplyChangesModal />)
					: null
				}
			</Wrapper>
		);
	}
}

export default withRouter(TopHeader);
